import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Encryptedid } from "../../Util/BcruptEncyptid";
import { groupData } from "../../Constant/ConstantData";

const CustomCarousel = ({ videoData = [], type, redirection }) => {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % videoData.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + videoData.length) % videoData.length);
  };

  const getVisibleSlides = () => {
    const visible = [];
    const slideCount =
      window.innerWidth <= 576
        ? 1
        : window.innerWidth <= 768
          ? 2
          : window.innerWidth <= 1064
            ? 4
            : window.innerWidth <= 1200
              ? 3
              : 4;
    for (let i = 0; i < slideCount; i++) {
      visible.push(videoData[(current + i) % videoData.length]);
    }
    return visible;
  };

  if (!videoData?.length) {
    return <p className="text-center">No videos available</p>;
  }

  const gotoPlayback = (id, video_Id) => {
    navigate(`/VideoShorts/${Encryptedid(id)}/${video_Id}`, {
      state: { page: "dashboard" },
    });
  };

  return (
    <Container className="popular-data-sec position-relative text-center" fluid>
      <Row className="justify-content-center px-1 mb-2 g-2">
        {getVisibleSlides()?.map((slide, index) => (
          <Col
            key={slide.id || index}
            xs={12}
            sm={6}
            md={4}
            lg={3}
            className="d-flex justify-content-center"
          >
            <Card
              className="custom-card shadow-sm border-0"
              style={{
                borderRadius: "16px",
                overflow: "hidden",
                maxWidth: "100%",
              }}
            >
              <div style={{ position: "relative" }}>
                <Card.Img
                  variant="top"
                  src={
                    slide.cover_url || require("../../Assets/Images/clogo.png")
                  }
                  alt={slide.title}
                  style={{
                    height: "345px",
                    width: "100%",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  onClick={() => redirection && gotoPlayback(slide.category, slide._id)}
                />
                {/* <span
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    background: "rgba(0,0,0,0.6)",
                    color: "#fff",
                    padding: "4px 10px",
                    borderRadius: "12px",
                    fontSize: "0.8rem",
                  }}
                >
                  {slide.tag || `#${index + 1}`}
                </span> */}
              </div>

              <Card.Body className="text-start p-2">
                {/* <Card.Title
                  className="fs-6 fw-semibold"
                  style={{ minHeight: "28px" }}
                >
                  {slide.title}
                </Card.Title> */}
                <div className="new-icons-main">
                  <div className="new-icons-sec">
                    <h6>{slide.title}</h6>
                  </div>
                  <div className="insight-sec d-flex">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      role="img"
                    >
                      <rect
                        x="3"
                        y="8"
                        width="4"
                        height="13"
                        rx="1.5"
                        fill="#6070A8"
                      />
                      <rect
                        x="10"
                        y="4"
                        width="4"
                        height="17"
                        rx="1.5"
                        fill="#6070A8"
                      />
                      <rect
                        x="17"
                        y="11"
                        width="4"
                        height="10"
                        rx="1.5"
                        fill="#6070A8"
                      />
                    </svg>
                    <h6>#{((current + index) % videoData.length) + 1}</h6>
                  </div>
                  {type !== "Staff" ? (
                    <>
                      <div className="insight-sec d-flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6070A8"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M2.5 12s3.5-7.5 9.5-7.5S21.5 12 21.5 12s-3.5 7.5-9.5 7.5S2.5 12 2.5 12z" />
                          <circle cx="12" cy="12" r="3.2" />
                        </svg>
                        <h6>
                          {slide?.views || 0}{" "}
                          {slide?.views === 1 ? "view" : "views"}
                        </h6>
                      </div>
                      <div className="insight-sec d-flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6070A8"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M20.8 8.6c0 6.1-7.3 10.6-8.3 11.3-1-.7-8.3-5.2-8.3-11.3C4.2 6 6.5 4 9.2 4c1.6 0 3 .8 3.6 2 0.6-1.2 2-2 3.6-2 2.7 0 5 2 5 4.6z" />
                        </svg>
                        <h6>
                          {slide?.likes || 0}{" "}
                          {slide?.likes === 1 ? "like" : "likes"}
                        </h6>
                      </div>
                      <div className="insight-sec d-flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6070A8"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
                        </svg>
                        <h6>
                          {slide?.saves || 0}{" "}
                          {slide?.saves === 1 ? "save" : "saves"}
                        </h6>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="insight-sec d-flex my-2">
                        <h6 style={{ fontSize: "14px" }}>
                          {slide?.categoryTitle}
                        </h6>
                      </div>
                      <div className="d-flex flex-wrap gap-1">
                        {slide?.group?.map((id, index) => {
                          const group = groupData.find((g) => g.id === id);
                          return (
                            group?.name && (
                              <button
                                key={`${id}-${index}`}
                                className="group-button rounded-pill text-nowrap m-0"
                                style={{ fontSize: "9px" }}
                                title={group.name}
                              >
                                {group.name}
                              </button>
                            )
                          );
                        })}
                      </div>{" "}
                    </>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Navigation */}
      {/* Navigation arrows */}
      <button
        onClick={prevSlide}
        className="left-btn"
        style={{
          position: "absolute",
          top: "42%",
          left: "-19px",
          transform: "translateY(-50%)",
          background: "transparent",
          border: "none",
          padding: 0,
          zIndex: 10,
        }}
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 48 48"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M30 12 L30 36 L12 24 Z" fill="#2E3472" />
        </svg>
      </button>

      <button
        onClick={nextSlide}
        className="right-btn"
        style={{
          position: "absolute",
          top: "42%",
          right: "26px",
          transform: "translateY(-50%)",
          background: "transparent",
          border: "none",
          padding: 0,
          zIndex: 10,
        }}
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 48 48"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M18 12 L18 36 L36 24 Z" fill="#2E3472" />
        </svg>
      </button>
    </Container>
  );
};

export default CustomCarousel;
